import { useEffect, useState } from 'react';
import { markingApi } from '../../api/marking';
import { hasCryptoTail } from '../../utils/dataMatrix';

interface Props {
  code: string;
  scale?: number;
  fetcher?: (code: string, scale: number) => Promise<string>;
}

const DataMatrixImage: React.FC<Props> = ({ code, scale = 4, fetcher }) => {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  // Марки из ШУТ 1С хранят плоский код без криптохвоста — неполную
  // DataMatrix не показываем нигде (rev. 2026-09-14). Полный код появится
  // после физического сканирования бутылки (обогащение raw_code).
  const noCryptoTail = !!code && !hasCryptoTail(code);

  useEffect(() => {
    if (!code || noCryptoTail) return;
    let objectUrl: string | null = null;
    let cancelled = false;

    (fetcher || markingApi.generateDataMatrixSvg)(code, scale)
      .then((u) => {
        if (cancelled) {
          URL.revokeObjectURL(u);
          return;
        }
        objectUrl = u;
        setUrl(u);
        setError(null);
      })
      .catch((e) => {
        if (cancelled) return;
        console.error('DataMatrix load error:', e);
        setError('Не удалось загрузить DataMatrix');
      });

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [code, scale, fetcher, noCryptoTail]);

  if (noCryptoTail) {
    return (
      <span
        style={{
          display: 'inline-block',
          padding: '8px 12px',
          border: '1px dashed #fa8c16',
          borderRadius: 6,
          fontSize: 12,
          color: '#ad6800',
          textAlign: 'center',
          maxWidth: 240,
        }}
      >
        Марка из 1С без криптохвоста — отсканируйте товар сканером
      </span>
    );
  }

  if (error) {
    return <span style={{ color: 'red', fontSize: 12 }}>{error}</span>;
  }

  if (!url) {
    return <span style={{ fontSize: 12, color: '#888' }}>Загрузка...</span>;
  }

  return (
    <img
      src={url}
      alt="Data Matrix"
      style={{
        display: 'block',
        imageRendering: 'pixelated',
      }}
    />
  );
};

export default DataMatrixImage;
